<template lang="html">
  <div class="row no-padding no-margin middle-xs slider">
    <!-- Chevrons -->
    <div class="center-absolute-middle" style="left: 0px">
      <pl-button class="pl-icon" style="margin: 0" @click.native="handleBack">
        <i class="fas fa-chevron-left"></i>
      </pl-button>
    </div>

    <div class="center-absolute-middle" style="right: 0px">
      <pl-button
        class="pl-icon"
        style="margin: 0"
        @click.native="handleForward"
      >
        <i class="fas fa-chevron-right"></i>
      </pl-button>
    </div>

    <!-- Slides -->
    <div class="slides" id="slider-track">

      <div
        :id="`slide-${index + 1}`"
        @click="slide.handler()"
        class="pane clickable"
        v-for="(slide, index) in pages"
      >
        <img
          :src="`/static/dashboard/${slide.image}.svg`"
          style="height: 50px; margin-right: 10px"
          alt=""
        />
        <div>
          <div
            style="
              width: 220px;
              color: #797979;
              font-size: 24px;
              font-weight: 600;
              line-height: 29px;
            "
          >
            {{ slide.main_text }}
          </div>
          
          <div
            style="
              color: #72ccd7;
              font-size: 16px;
              line-height: 19px;
              font-weight: 500;
            "
          >
            {{ slide.secondary_text }}
          </div>
          
        </div>
        <i
        v-my-tooltip="tooltip"
        class="fas fa-external-link-alt"
        style="font-size: 10px; vertical-align: top;"
        aria-hidden="true"
      ></i>
      </div>
    </div>

    <!-- Scrolling dots -->
    <div class="dot-container">
      <button
        v-for="(page, index) in pages"
        @click="handleSlideClick(index)"
        class="dot"
        :class="{ selected: selected_page_number === index + 1 }"
      />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tooltip: 'Clicking will open the external link on a new tab',
        // Want to change one of the panes in the slider (edit, remove, or add)?
        // You can do that all here in the `pages` data field.
        pages: [
          {
            image: 'new_to_parlay',
            main_text: 'New To Parlay?',
            secondary_text: '(see resource folder)',
            handler() {
              window.open(
                'https://drive.google.com/open?id=1btY3bRN7Fyt_lbKR5f9SE4mWcCrjZMt_'
              );
            },
          },
          {
            image: 'running_plc',
            main_text: 'Running a PLC?',
            secondary_text: '(download slides)',
            handler() {
              window.open(
                'https://drive.google.com/open?id=1LXIqAXLeUtHF4HiQv6aFPlLSqffbracdupJr2Fsxpw4'
              );
            },
          },
          {
            image: 'get_certified',
            main_text: 'Get Certified',
            secondary_text: '(view requirements)',
            handler() {
              window.open(
                'https://docs.google.com/forms/d/e/1FAIpQLSehcF_IqpF-Aktcv1-WlAK-f0jv9rUglF5zAAHCSdUI8Jst7w/viewform'
              );
            },
          },
        ],
        selected_page_number: 1,
        interval: null,
      };
    },
    computed: {},
    methods: {
      handleForward() {
        this.resetInterval();
        this.selected_page_number === this.pages.length
          ? this.slideToPage(1)
          : this.slideToPage(this.selected_page_number + 1);
      },
      handleBack() {
        this.resetInterval();
        this.selected_page_number === 1
          ? this.slideToPage(this.pages.length)
          : this.slideToPage(this.selected_page_number - 1);
      },
      slideToPage(page_number) {
        this.selected_page_number = page_number;
        const track = document.getElementById('slider-track');
        const track_width = track.offsetWidth;
        track.scroll(track_width * (page_number - 1), 0);
      },
      handleSlideClick(index) {
        this.slideToPage(index + 1);
        this.resetInterval();
      },
      resetInterval() {
        clearInterval(this.interval);
        this.setUpInterval();
      },
      setUpInterval() {
        this.interval = setInterval(this.handleForward, 5000);
      },
    },
    mounted() {
      this.setUpInterval();
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl'

  .slider
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: hidden;
    position: relative;

  #slider-track {
    height: 100%
    width: 100%
    display: flex;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    /*
    scroll-snap-points-x: repeat(300px);
    scroll-snap-type: mandatory;
    */
  }

  .center-absolute-middle
    position: absolute;
    height: 40px
    margin-top: -20px
    top: 50%;

  .pane {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    // transform-origin: center center;
    // transform: scale(1);
    // transition: transform 0.5s;
    // position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dot-container
    position: absolute;
    width: 100px
    margin-left: -50px
    bottom: 10px
    left: 50%

  .dot
    margin: 3px;
    border: none;
    border-radius: 50%
    padding: 0
    width: 12px
    height: 12px
    background-color: pl-slate
    &:active
      background-color: pl-primary
  .selected
    background-color: pl-primary
</style>



// WEBPACK FOOTER //
// slidingButton.vue?81c62ca8